module.exports = __webpack_public_path__ + "img/logo-movimentacao.18110d4f.svg";